import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import { Col, Form, Modal, Row, Table } from "react-bootstrap";
import downArrow from "../../Assets/Images/Header/downArrow.svg";
import moment from "moment";
import closeBtn from "../../Assets/Images/Action Icons/closeIcon.svg";
import { commonService } from "../../utils/commonService";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";

const SingleDateSummaryModal = ({
  requestFor = "",
  RMSRequest = null,
  isTotalHeatMapClick,
  showModal = true,
  closeModal,
  asOfDate,
  selectedDate = "",
  pickupDate,
  propertyDetail,
  fromHeatMap,
  PickupDays,
}) => {
  const [singleDateData, setSingleDateData] = useState(null);
  const [loading, setLoading] = useState(true); // Set to true initially to show loader instantly
  const totalRef = useRef();
  const countForPickupAdrDivision = useRef();
  const [selectedPickupDateType, setSelectedPickupDateType] = useState(
    PickupDays ? PickupDays : "7Day",
  );
  let subtractdays = PickupDays ? parseInt(PickupDays.replace("Day")) : 7;
  let date = moment(asOfDate).subtract(subtractdays, "d");
  const pickupDateRef = useRef(date);
  const [changeDate, setChangeDate] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const inFlightRequestRef = useRef(false);
  const activeRequestKeyRef = useRef("");
  let maxDate = new Date();
  if (asOfDate) {
    let date = new Date(asOfDate);
    maxDate = date.setDate(date.getDate() - 1);
  }

  let totalRoom = 0,
    totalRoomLy = 0,
    totalLOS = 0,
    totalPickupFrom = 0,
    totalAdrPickup = 0,
    totalAdr = 0,
    totalAdrLy = 0,
    totalRevenue = 0,
    totalRevenueLy = 0;

  const handleRequestFor = () => {
    const baseRequest = {
      AsOfDate: moment(asOfDate).format("YYYY-MM-DD"),
      propertyCode: propertyDetail?.propertyCode,
      PickUpDate: moment(pickupDateRef.current).format("YYYY-MM-DD"),
    };

    // HeatMap request
    if (isTotalHeatMapClick) {
      return {
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.DAILY_SUMMARY.SINGLE_DATE_SUMMARY_DAY_WISE,
        request: {
          ...baseRequest,
          startDate: moment(selectedDate?.startDateObj).format("YYYY-MM-DD"),
          endDate: moment(selectedDate?.endDateObj).format("YYYY-MM-DD"),
        },
      };
    }

    // RequestFor based API
    switch (requestFor) {
      case "Transient_RMS":
        return {
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.GROUP_WASH.GROUP_WASH_GROUP_TRANSIENT_DRILLDOWN_SUMMARY,
          request: {
            ...baseRequest,
            SelectedDate: moment(selectedDate).format("YYYY-MM-DD"),
            SegmentType: "Transient",
          },
        };

      case "GroupBlock_Confirm":
        return {
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.GROUP_WASH.GROUP_WASH_GROUP_TRANSIENT_DRILLDOWN_SUMMARY,
          request: {
            ...baseRequest,
            SelectedDate: moment(selectedDate).format("YYYY-MM-DD"),
            SegmentType: "Group",
          },
        };

      default:
        return {
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.WIDGET_MODULE.SINGLE_DATE_SUMMARY,
          request: {
            ...baseRequest,
            SelectedDate: moment(selectedDate).format("YYYY-MM-DD"),
          },
        };
    }
  };

  const getSingleDateData = async () => {
    const { url, request } = handleRequestFor();

    setLoading(true);
    let singleDateResponse = await apiCall(
      {
        method: "POST",
        url: url,
        body: request,
      },
      false,
    );

    let response = apiResponse(false, singleDateResponse);

    if (response?.isValidate) {
      const dataFromApi = response?.data?.data || [];
      const toNumber = (value) => {
        const parsedValue = Number(value);
        return Number.isFinite(parsedValue) ? parsedValue : 0;
      };

      const averageNonZeroPickupAdr = (items = []) => {
        let sum = 0;
        let count = 0;

        for (let i = 0; i < items.length; i++) {
          const pickupAdr = toNumber(items[i]?.pickupAdr);
          if (pickupAdr !== 0) {
            sum = sum + pickupAdr;
            count = count + 1;
          }
        }

        return count > 0 ? Math.round(sum / count) : 0;
      };

      totalRef.current = {
        room: 0,
        lyRoom: 0,
        LOS: 0,
        pickupFrom: 0,
        pickupAdr: 0,
        adr: 0,
        lyAdr: 0,
        revenue: 0,
        lyRevenue: 0,
      };
      countForPickupAdrDivision.current = 0;

      const marketSegmentMap = new Map();

      for (let i = 0; i < dataFromApi.length; i++) {
        const item = dataFromApi[i];
        const marketSegmentName = item?.MarketSegment || "Unknown";
        const rateCodeName = `${item?.RateCode || ""}${
          item?.RateCodeDescript ? ` - ${item?.RateCodeDescript}` : ""
        }`;
        const companyName = item?.Company || "Unknown";

        const currentRoom = toNumber(item?.CURRENT_ROOM);
        const lyRoom = toNumber(item?.LY_ROOM);
        const pickupFrom = toNumber(item?.PICKUP_FROM_ROOM);
        const pickupAdr = toNumber(item?.ADR_PICKUP);
        const currentAdr = toNumber(item?.CURRENT_ADR);
        const lyAdr = toNumber(item?.LY_ADR);
        const currentRevenue = toNumber(item?.CURRENT_REVENUE);
        const lyRevenue = toNumber(item?.LY_Revenue);
        const los = toNumber(item?.LOS);

        totalRef.current.room = totalRef.current.room + currentRoom;
        totalRef.current.lyRoom = totalRef.current.lyRoom + lyRoom;
        totalRef.current.LOS = totalRef.current.LOS + los;
        totalRef.current.pickupFrom = totalRef.current.pickupFrom + pickupFrom;
        totalRef.current.adr = totalRef.current.adr + currentAdr;
        totalRef.current.lyAdr = totalRef.current.lyAdr + lyAdr;
        totalRef.current.revenue = totalRef.current.revenue + currentRevenue;
        totalRef.current.lyRevenue = totalRef.current.lyRevenue + lyRevenue;

        if (!marketSegmentMap.has(marketSegmentName)) {
          marketSegmentMap.set(marketSegmentName, {
            name: marketSegmentName,
            guid: commonService.GenerateGUID(),
            room: 0,
            lyRoom: 0,
            arrDate: "",
            LOS: 0,
            pickupFrom: 0,
            pickupAdr: 0,
            adr: 0,
            lyAdr: 0,
            revenue: 0,
            lyRevenue: 0,
            items: [],
            rateCodeMap: new Map(),
          });
        }

        const marketSegmentNode = marketSegmentMap.get(marketSegmentName);
        marketSegmentNode.room = marketSegmentNode.room + currentRoom;
        marketSegmentNode.lyRoom = marketSegmentNode.lyRoom + lyRoom;
        marketSegmentNode.LOS = marketSegmentNode.LOS + los;
        marketSegmentNode.pickupFrom = marketSegmentNode.pickupFrom + pickupFrom;
        marketSegmentNode.pickupAdr = marketSegmentNode.pickupAdr + pickupAdr;
        marketSegmentNode.revenue = marketSegmentNode.revenue + currentRevenue;
        marketSegmentNode.lyRevenue = marketSegmentNode.lyRevenue + lyRevenue;

        if (!marketSegmentNode.rateCodeMap.has(rateCodeName)) {
          marketSegmentNode.rateCodeMap.set(rateCodeName, {
            name: rateCodeName,
            guid: commonService.GenerateGUID(),
            room: 0,
            lyRoom: 0,
            arrDate: "",
            LOS: 0,
            pickupFrom: 0,
            pickupAdr: 0,
            adr: 0,
            lyAdr: 0,
            revenue: 0,
            lyRevenue: 0,
            items: [],
            companyMap: new Map(),
          });
        }

        const rateCodeNode = marketSegmentNode.rateCodeMap.get(rateCodeName);
        rateCodeNode.room = rateCodeNode.room + currentRoom;
        rateCodeNode.lyRoom = rateCodeNode.lyRoom + lyRoom;
        rateCodeNode.LOS = rateCodeNode.LOS + los;
        rateCodeNode.pickupFrom = rateCodeNode.pickupFrom + pickupFrom;
        rateCodeNode.pickupAdr = rateCodeNode.pickupAdr + pickupAdr;
        rateCodeNode.revenue = rateCodeNode.revenue + currentRevenue;
        rateCodeNode.lyRevenue = rateCodeNode.lyRevenue + lyRevenue;

        if (!rateCodeNode.companyMap.has(companyName)) {
          rateCodeNode.companyMap.set(companyName, {
            name: companyName,
            guid: commonService.GenerateGUID(),
            room: 0,
            lyRoom: 0,
            arrDate: "",
            LOS: 0,
            pickupFrom: 0,
            pickupAdr: 0,
            adr: 0,
            lyAdr: 0,
            revenue: 0,
            lyRevenue: 0,
            items: [],
          });
        }

        const companyNode = rateCodeNode.companyMap.get(companyName);
        companyNode.room = companyNode.room + currentRoom;
        companyNode.lyRoom = companyNode.lyRoom + lyRoom;
        companyNode.LOS = companyNode.LOS + los;
        companyNode.pickupFrom = companyNode.pickupFrom + pickupFrom;
        companyNode.pickupAdr = companyNode.pickupAdr + pickupAdr;
        companyNode.revenue = companyNode.revenue + currentRevenue;
        companyNode.lyRevenue = companyNode.lyRevenue + lyRevenue;

        companyNode.items.push({
          name: item?.GuestName,
          guid: commonService.GenerateGUID(),
          items: "",
          room: item?.CURRENT_ROOM,
          lyRoom: item?.LY_ROOM,
          arrDate: item?.ArrDate,
          LOS: item?.LOS,
          pickupFrom: item?.PICKUP_FROM_ROOM,
          pickupAdr: item?.ADR_PICKUP,
          adr:
            currentRevenue > 0 && currentRoom > 0
              ? Math.round(currentRevenue / currentRoom)
              : 0,
          lyAdr:
            lyRevenue > 0 && lyRoom > 0 ? Math.round(lyRevenue / lyRoom) : 0,
          revenue: item?.CURRENT_REVENUE,
          lyRevenue: item?.LY_Revenue,
        });
      }

      const groupingJson = [];
      const marketSegments = Array.from(marketSegmentMap.values());

      for (let i = 0; i < marketSegments.length; i++) {
        const marketSegmentNode = marketSegments[i];
        const rateCodes = Array.from(marketSegmentNode.rateCodeMap.values());

        for (let j = 0; j < rateCodes.length; j++) {
          const rateCodeNode = rateCodes[j];
          const companies = Array.from(rateCodeNode.companyMap.values());

          for (let k = 0; k < companies.length; k++) {
            const companyNode = companies[k];
            companyNode.pickupAdr = averageNonZeroPickupAdr(companyNode.items);
            companyNode.adr =
              companyNode.revenue > 0 && companyNode.room > 0
                ? Math.round(companyNode.revenue / companyNode.room)
                : 0;
            companyNode.lyAdr =
              companyNode.lyRevenue > 0 && companyNode.lyRoom > 0
                ? Math.round(companyNode.lyRevenue / companyNode.lyRoom)
                : 0;
          }

          rateCodeNode.items = companies;
          rateCodeNode.pickupAdr = averageNonZeroPickupAdr(rateCodeNode.items);
          rateCodeNode.adr =
            rateCodeNode.revenue > 0 && rateCodeNode.room > 0
              ? Math.round(rateCodeNode.revenue / rateCodeNode.room)
              : 0;
          rateCodeNode.lyAdr =
            rateCodeNode.lyRevenue > 0 && rateCodeNode.lyRoom > 0
              ? Math.round(rateCodeNode.lyRevenue / rateCodeNode.lyRoom)
              : 0;
          delete rateCodeNode.companyMap;
        }

        marketSegmentNode.items = rateCodes;
        marketSegmentNode.pickupAdr = averageNonZeroPickupAdr(
          marketSegmentNode.items,
        );
        marketSegmentNode.adr =
          marketSegmentNode.revenue > 0 && marketSegmentNode.room > 0
            ? Math.round(marketSegmentNode.revenue / marketSegmentNode.room)
            : 0;
        marketSegmentNode.lyAdr =
          marketSegmentNode.lyRevenue > 0 && marketSegmentNode.lyRoom > 0
            ? Math.round(marketSegmentNode.lyRevenue / marketSegmentNode.lyRoom)
            : 0;
        delete marketSegmentNode.rateCodeMap;

        groupingJson.push(marketSegmentNode);
      }

      totalRef.current.pickupAdr = averageNonZeroPickupAdr(groupingJson);
      countForPickupAdrDivision.current = groupingJson.filter(
        (item) => item.pickupAdr !== 0,
      ).length;

      setExpandedRows({});
      setSingleDateData(groupingJson);
      setLoading(false);
    }

    if (!response?.isValidate) {
      setExpandedRows({});
      setSingleDateData(null);
      setLoading(false);
    }
  };

  const toggleExpandedRow = (guid) => {
    setExpandedRows((prev) => ({
      ...prev,
      [guid]: !prev[guid],
    }));
  };

  const getBucketClickedDateData = async () => {
    setLoading(true);
    let singleDateResponse = null;
    if (requestFor === "Monthly_Cancellation_Window") {
      RMSRequest.pickupdate = moment(pickupDateRef.current).format(
        "YYYY-MM-DD",
      );
      RMSRequest["asofdate"] = moment(asOfDate).format("YYYY-MM-DD");
      RMSRequest["propertycode"] = propertyDetail?.propertyCode;

      singleDateResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.WIDGET_MODULE.SNP_MONTHLY_CANCELLATION_DRILLDOWN,
          body: RMSRequest,
        },
        false,
      );
    } else if (requestFor === "PMS_Booking_Window") {
      RMSRequest.pickupdate = moment(pickupDateRef.current).format("YYYY-MM-DD",);
      RMSRequest["asofdate"] = moment(asOfDate).format("YYYY-MM-DD");
      RMSRequest["propertycode"] = propertyDetail?.propertyCode;

      singleDateResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.WIDGET_MODULE.PMS_SNP_MONTHLY_BOOKING_SUMMARY,
          body: RMSRequest,
        },
        false,
      );
    } else if (requestFor === "CM_Booking_Window") {
      RMSRequest.pickupdate = moment(pickupDateRef.current).format("YYYY-MM-DD",);
      RMSRequest["asofdate"] = moment(asOfDate).format("YYYY-MM-DD");
      RMSRequest["propertycode"] = propertyDetail?.propertyCode;

      singleDateResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.RNX.CM_RNX_MONTHLY_BOOKING_DRILLDOWN,
          body: RMSRequest,
        },
        false,
      );
    } else {
      RMSRequest.pickupdate = moment(pickupDateRef.current).format(
        "YYYY-MM-DD",
      );
      RMSRequest.selecteddate = moment(selectedDate).format("YYYY-MM-DD");
      RMSRequest.formattedpreviousyeardate = moment(selectedDate)
        .subtract(1, "year")
        .format("YYYY-MM-DD");

      singleDateResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.WIDGET_MODULE.SINGLE_DATE_SUMMARY_AVGLEADTIME,
          body: RMSRequest,
        },
        false,
      );
    }

    let response = apiResponse(false, singleDateResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data;
      let groupingJson = [];
      totalRef.current = {
        room: 0,
        lyRoom: 0,
        LOS: 0,
        pickupFrom: 0,
        pickupAdr: 0,
        adr: 0,
        lyAdr: 0,
        revenue: 0,
        lyRevenue: 0,
      };
      countForPickupAdrDivision.current = 0;

      const checkMarketSegmentExist = (marketSegmentName) => {
        let filterData = groupingJson?.findIndex(
          (x) => x.name === marketSegmentName,
        );

        return filterData;
      };

      const checkRateCodeExist = (indexOfMarketSegment, rateCodeName) => {
        let filterData = groupingJson[indexOfMarketSegment]?.items?.findIndex(
          (x) => x.name === rateCodeName,
        );
        return filterData;
      };

      const checkCompanyExists = (
        indexOfMarketSegment,
        indexofRateCode,
        companyName,
      ) => {
        let filterData = groupingJson[indexOfMarketSegment].items[
          indexofRateCode
        ]?.items?.findIndex((x) => x.name === companyName);

        return filterData;
      };

      const marketSegmentWiseTotal = (marketSegmentName) => {
        let obj = {
          room: 0,
          lyRoom: 0,
          LOS: 0,
          pickupFrom: 0,
          pickupAdr: 0,
          adr: 0,
          lyAdr: 0,
          revenue: 0,
          lyRevenue: 0,
        };
        dataFromApi?.map((item, index) => {
          if (item.MarketSegment === marketSegmentName) {
            obj.room = obj.room + parseInt(item?.CURRENT_ROOM);
            obj.lyRoom = obj.lyRoom + parseInt(item?.LY_ROOM);
            obj.pickupFrom = obj.pickupFrom + parseInt(item?.PICKUP_FROM_ROOM);
            obj.pickupAdr = obj.pickupAdr + parseInt(item?.ADR_PICKUP);
            obj.adr = obj.adr + parseInt(item?.CURRENT_ADR);
            obj.lyAdr = obj.lyAdr + parseInt(item?.LY_ADR);
            obj.revenue = obj.revenue + parseInt(item?.CURRENT_REVENUE);
            obj.lyRevenue =
              obj.lyRevenue +
              (item?.LY_Revenue ? parseInt(item?.LY_Revenue) : 0);
            obj.LOS = obj.LOS + parseInt(item?.LOS);
          }
        });
        if (obj.pickupAdr > 0) {
          countForPickupAdrDivision.current =
            countForPickupAdrDivision.current + 1;
        }
        totalRef.current.room = totalRef.current.room + obj.room;
        totalRef.current.lyRoom = totalRef.current.lyRoom + obj.lyRoom;
        totalRef.current.LOS = totalRef.current.LOS + obj.LOS;
        totalRef.current.pickupFrom =
          totalRef.current.pickupFrom + obj.pickupFrom;
        totalRef.current.pickupAdr = totalRef.current.pickupAdr + obj.pickupAdr;
        totalRef.current.adr = totalRef.current.adr + obj.adr;
        totalRef.current.lyAdr = totalRef.current.lyAdr + obj.lyAdr;
        totalRef.current.revenue = totalRef.current.revenue + obj.revenue;
        totalRef.current.lyRevenue = totalRef.current.lyRevenue + obj.lyRevenue;
        return obj;
      };

      const rateCodeWiseTotal = (marketSegmentName, rateCodeName) => {
        let obj = {
          room: 0,
          lyRoom: 0,
          pickupFrom: 0,
          pickupAdr: 0,
          adr: 0,
          lyAdr: 0,
          revenue: 0,
          lyRevenue: 0,
          LOS: 0,
        };
        dataFromApi?.map((item, index) => {
          if (
            item.MarketSegment === marketSegmentName &&
            item.RateCode === rateCodeName
          ) {
            obj.room = obj.room + parseInt(item?.CURRENT_ROOM);
            obj.lyRoom = obj.lyRoom + parseInt(item?.LY_ROOM);
            obj.pickupFrom = obj.pickupFrom + parseInt(item?.PICKUP_FROM_ROOM);
            obj.pickupAdr = obj.pickupAdr + parseInt(item?.ADR_PICKUP);
            obj.adr = obj.adr + parseInt(item?.CURRENT_ADR);
            obj.lyAdr = obj.lyAdr + parseInt(item?.LY_ADR);
            obj.revenue = obj.revenue + parseInt(item?.CURRENT_REVENUE);
            obj.lyRevenue =
              obj.lyRevenue +
              (item?.LY_Revenue ? parseInt(item?.LY_Revenue) : 0);
            obj.LOS = obj.LOS + parseInt(item?.LOS);
          }
        });
        return obj;
      };

      const companyWiseTotal = (
        marketSegmentName,
        rateCodeName,
        companyName,
      ) => {
        let obj = {
          room: 0,
          lyRoom: 0,
          pickupFrom: 0,
          pickupAdr: 0,
          adr: 0,
          lyAdr: 0,
          revenue: 0,
          lyRevenue: 0,
          LOS: 0,
        };
        dataFromApi?.map((item, index) => {
          if (
            item.MarketSegment === marketSegmentName &&
            item.RateCode === rateCodeName &&
            item.Company === companyName
          ) {
            obj.room = obj.room + parseInt(item?.CURRENT_ROOM);
            obj.lyRoom = obj.lyRoom + parseInt(item?.LY_ROOM);
            obj.pickupFrom = obj.pickupFrom + parseInt(item?.PICKUP_FROM_ROOM);
            obj.pickupAdr = obj.pickupAdr + parseInt(item?.ADR_PICKUP);
            obj.adr = obj.adr + parseInt(item?.CURRENT_ADR);
            obj.lyAdr = obj.lyAdr + parseInt(item?.LY_ADR);
            obj.revenue = obj.revenue + parseInt(item?.CURRENT_REVENUE);
            obj.lyRevenue =
              obj.lyRevenue +
              (item?.LY_Revenue ? parseInt(item?.LY_Revenue) : 0);
            obj.LOS = obj.LOS + parseInt(item?.LOS);
          }
        });
        return obj;
      };

      for (let i = 0; i < dataFromApi?.length; i++) {
        let indexOfMarketSegment = checkMarketSegmentExist(
          dataFromApi[i].MarketSegment,
        );
        if (indexOfMarketSegment >= 0) {
          let indexofRateCode = checkRateCodeExist(
            indexOfMarketSegment,
            `${dataFromApi[i].RateCode}${
              dataFromApi[i]?.RateCodeDescript
                ? ` - ${dataFromApi[i]?.RateCodeDescript}`
                : ""
            }`,
          );
          if (indexofRateCode >= 0) {
            let indexOfCompany = checkCompanyExists(
              indexOfMarketSegment,
              indexofRateCode,
              dataFromApi[i].Company,
            );
            if (indexOfCompany >= 0) {
              groupingJson[indexOfMarketSegment].items[indexofRateCode].items[
                indexOfCompany
              ].items = [
                ...groupingJson[indexOfMarketSegment].items[indexofRateCode]
                  ?.items[indexOfCompany]?.items,
                {
                  name: dataFromApi[i].GuestName,
                  guid: commonService.GenerateGUID(),
                  items: "",
                  room: dataFromApi[i].CURRENT_ROOM,
                  lyRoom: dataFromApi[i].LY_ROOM,
                  arrDate: dataFromApi[i]?.ArrDate,
                  LOS: dataFromApi[i]?.LOS,
                  pickupFrom: dataFromApi[i].PICKUP_FROM_ROOM,
                  pickupAdr: dataFromApi[i].ADR_PICKUP,
                  // adr: dataFromApi[i].CURRENT_ADR,
                  adr: dataFromApi[i].CURRENT_REVENUE
                    ? Math.round(
                        dataFromApi[i].CURRENT_REVENUE /
                          dataFromApi[i].CURRENT_ROOM,
                      )
                    : 0,
                  //   lyAdr: dataFromApi[i].LY_ADR,
                  lyAdr: dataFromApi[i].LY_Revenue
                    ? Math.round(
                        dataFromApi[i].LY_Revenue / dataFromApi[i].LY_ROOM,
                      )
                    : 0,
                  revenue: dataFromApi[i].CURRENT_REVENUE,
                  lyRevenue: dataFromApi[i].LY_Revenue,
                },
              ];
            } else {
              let companyTotal = companyWiseTotal(
                dataFromApi[i].MarketSegment,
                dataFromApi[i].RateCode,
                dataFromApi[i].Company,
              );
              groupingJson[indexOfMarketSegment].items[indexofRateCode].items =
                [
                  ...groupingJson[indexOfMarketSegment].items[indexofRateCode]
                    .items,
                  {
                    name: dataFromApi[i].Company,
                    guid: commonService.GenerateGUID(),
                    room: companyTotal?.room,
                    lyRoom: companyTotal?.lyRoom,
                    arrDate: "",
                    LOS: companyTotal?.LOS,
                    pickupFrom: companyTotal?.pickupFrom,
                    pickupAdr: companyTotal?.pickupAdr,
                    // adr: companyTotal?.adr,
                    adr: companyTotal?.revenue
                      ? Math.round(companyTotal?.revenue / companyTotal?.room)
                      : 0,
                    // lyAdr: companyTotal?.lyAdr,
                    lyAdr: companyTotal?.lyRevenue
                      ? Math.round(
                          companyTotal?.lyRevenue / companyTotal?.lyRoom,
                        )
                      : 0,
                    revenue: companyTotal?.revenue,
                    lyRevenue: companyTotal?.lyRevenue,
                    items: [
                      {
                        name: dataFromApi[i].GuestName,
                        guid: commonService.GenerateGUID(),
                        items: "",
                        room: dataFromApi[i].CURRENT_ROOM,
                        lyRoom: dataFromApi[i].LY_ROOM,
                        arrDate: dataFromApi[i]?.ArrDate,
                        LOS: dataFromApi[i]?.LOS,
                        pickupFrom: dataFromApi[i].PICKUP_FROM_ROOM,
                        pickupAdr: dataFromApi[i].ADR_PICKUP,
                        // adr: dataFromApi[i].CURRENT_ADR,
                        adr: dataFromApi[i].CURRENT_REVENUE
                          ? Math.round(
                              dataFromApi[i].CURRENT_REVENUE /
                                dataFromApi[i].CURRENT_ROOM,
                            )
                          : 0,
                        // lyAdr: dataFromApi[i].LY_ADR,
                        lyAdr: dataFromApi[i].LY_Revenue
                          ? Math.round(
                              dataFromApi[i].LY_Revenue /
                                dataFromApi[i].LY_ROOM,
                            )
                          : 0,
                        revenue: dataFromApi[i].CURRENT_REVENUE,
                        lyRevenue: dataFromApi[i].LY_Revenue,
                      },
                    ],
                  },
                ];
            }
          } else {
            let rateCodeTotal = rateCodeWiseTotal(
              dataFromApi[i].MarketSegment,
              dataFromApi[i].RateCode,
            );
            let companyTotal = companyWiseTotal(
              dataFromApi[i].MarketSegment,
              dataFromApi[i].RateCode,
              dataFromApi[i].Company,
            );
            groupingJson[indexOfMarketSegment].items = [
              ...groupingJson[indexOfMarketSegment].items,
              {
                name: `${dataFromApi[i].RateCode}${
                  dataFromApi[i]?.RateCodeDescript
                    ? ` - ${dataFromApi[i]?.RateCodeDescript}`
                    : ""
                }`,
                guid: commonService.GenerateGUID(),
                room: rateCodeTotal?.room,
                lyRoom: rateCodeTotal?.lyRoom,
                arrDate: "",
                LOS: rateCodeTotal?.LOS,
                pickupFrom: rateCodeTotal?.pickupFrom,
                pickupAdr: rateCodeTotal?.pickupAdr,
                // adr: rateCodeTotal?.adr,
                adr: rateCodeTotal?.revenue
                  ? Math.round(rateCodeTotal?.revenue / rateCodeTotal?.room)
                  : 0,
                // lyAdr: rateCodeTotal?.lyAdr,
                lyAdr: rateCodeTotal?.lyRevenue
                  ? Math.round(rateCodeTotal?.lyRevenue / rateCodeTotal?.lyRoom)
                  : 0,
                revenue: rateCodeTotal?.revenue,
                lyRevenue: rateCodeTotal?.lyRevenue,
                items: [
                  {
                    name: dataFromApi[i].Company,
                    guid: commonService.GenerateGUID(),
                    room: companyTotal?.room,
                    lyRoom: companyTotal?.lyRoom,
                    arrDate: "",
                    LOS: companyTotal?.LOS,
                    pickupFrom: companyTotal?.pickupFrom,
                    pickupAdr: companyTotal?.pickupAdr,
                    // adr: companyTotal?.adr,
                    adr: companyTotal?.revenue
                      ? Math.round(companyTotal?.revenue / companyTotal?.room)
                      : 0,
                    // lyAdr: companyTotal?.lyAdr,
                    lyAdr: companyTotal?.lyRevenue
                      ? Math.round(
                          companyTotal?.lyRevenue / companyTotal?.lyRoom,
                        )
                      : 0,
                    revenue: companyTotal?.revenue,
                    lyRevenue: companyTotal?.lyRevenue,
                    items: [
                      {
                        name: dataFromApi[i].GuestName,
                        guid: commonService.GenerateGUID(),
                        items: "",
                        room: dataFromApi[i].CURRENT_ROOM,
                        lyRoom: dataFromApi[i].LY_ROOM,
                        arrDate: dataFromApi[i]?.ArrDate,
                        LOS: dataFromApi[i]?.LOS,
                        pickupFrom: dataFromApi[i].PICKUP_FROM_ROOM,
                        pickupAdr: dataFromApi[i].ADR_PICKUP,
                        // adr: dataFromApi[i].CURRENT_ADR,
                        adr: dataFromApi[i].CURRENT_REVENUE
                          ? Math.round(
                              dataFromApi[i].CURRENT_REVENUE /
                                dataFromApi[i].CURRENT_ROOM,
                            )
                          : 0,
                        // lyAdr: dataFromApi[i].LY_ADR,
                        lyAdr: dataFromApi[i].LY_Revenue
                          ? Math.round(
                              dataFromApi[i].LY_Revenue /
                                dataFromApi[i].LY_ROOM,
                            )
                          : 0,
                        revenue: dataFromApi[i].CURRENT_REVENUE,
                        lyRevenue: dataFromApi[i].LY_Revenue,
                      },
                    ],
                  },
                ],
              },
            ];
          }
        } else {
          let marketSegmentTotal = marketSegmentWiseTotal(
            dataFromApi[i].MarketSegment,
          );
          let rateCodeTotal = rateCodeWiseTotal(
            dataFromApi[i].MarketSegment,
            dataFromApi[i].RateCode,
          );
          let companyTotal = companyWiseTotal(
            dataFromApi[i].MarketSegment,
            dataFromApi[i].RateCode,
            dataFromApi[i].Company,
          );
          let newObj = {
            name: dataFromApi[i].MarketSegment,
            guid: commonService.GenerateGUID(),
            room: marketSegmentTotal?.room,
            lyRoom: marketSegmentTotal?.lyRoom,
            arrDate: "",
            LOS: marketSegmentTotal?.LOS,
            pickupFrom: marketSegmentTotal?.pickupFrom,
            pickupAdr: marketSegmentTotal?.pickupAdr,
            // adr: marketSegmentTotal?.adr,
            adr: marketSegmentTotal?.revenue
              ? Math.round(
                  (marketSegmentTotal?.revenue
                    ? parseFloat(marketSegmentTotal?.revenue)
                    : 0) /
                    (marketSegmentTotal?.room
                      ? parseInt(marketSegmentTotal?.room)
                      : 0),
                )
              : 0,
            // lyAdr: marketSegmentTotal?.lyAdr,
            lyAdr: marketSegmentTotal?.lyRevenue
              ? Math.round(
                  marketSegmentTotal?.lyRevenue / marketSegmentTotal?.lyRoom,
                )
              : 0,
            revenue: marketSegmentTotal?.revenue,
            lyRevenue: marketSegmentTotal?.lyRevenue,
            items: [
              {
                name: `${dataFromApi[i].RateCode}${
                  dataFromApi[i]?.RateCodeDescript
                    ? ` - ${dataFromApi[i]?.RateCodeDescript}`
                    : ""
                }`,
                guid: commonService.GenerateGUID(),
                room: rateCodeTotal?.room,
                lyRoom: rateCodeTotal?.lyRoom,
                arrDate: "",
                LOS: rateCodeTotal?.LOS,
                pickupFrom: rateCodeTotal?.pickupFrom,
                pickupAdr: rateCodeTotal?.pickupAdr,
                // adr: rateCodeTotal?.adr,
                adr: rateCodeTotal?.revenue
                  ? Math.round(rateCodeTotal?.revenue / rateCodeTotal?.room)
                  : 0,
                // lyAdr: rateCodeTotal?.lyAdr,
                lyAdr: rateCodeTotal?.lyRevenue
                  ? Math.round(rateCodeTotal?.lyRevenue / rateCodeTotal?.lyRoom)
                  : 0,
                revenue: rateCodeTotal?.revenue,
                lyRevenue: rateCodeTotal?.lyRevenue,
                items: [
                  {
                    name: dataFromApi[i].Company,
                    guid: commonService.GenerateGUID(),
                    room: companyTotal?.room,
                    lyRoom: companyTotal?.lyRoom,
                    arrDate: "",
                    LOS: companyTotal?.LOS,
                    pickupFrom: companyTotal?.pickupFrom,
                    pickupAdr: companyTotal?.pickupAdr,
                    // adr: companyTotal?.adr,
                    adr: companyTotal?.revenue
                      ? Math.round(companyTotal?.revenue / companyTotal?.room)
                      : 0,
                    // lyAdr: companyTotal?.lyAdr,
                    lyAdr: companyTotal?.lyRevenue
                      ? Math.round(
                          companyTotal?.lyRevenue / companyTotal?.lyRoom,
                        )
                      : 0,
                    revenue: companyTotal?.revenue,
                    lyRevenue: companyTotal?.lyRevenue,
                    items: [
                      {
                        name: dataFromApi[i].GuestName,
                        guid: commonService.GenerateGUID(),
                        items: "",
                        room: dataFromApi[i].CURRENT_ROOM,
                        lyRoom: dataFromApi[i].LY_ROOM,
                        arrDate: dataFromApi[i]?.ArrDate,
                        LOS: dataFromApi[i]?.LOS,
                        pickupFrom: dataFromApi[i].PICKUP_FROM_ROOM,
                        pickupAdr: dataFromApi[i].ADR_PICKUP,
                        // adr: dataFromApi[i].CURRENT_ADR,
                        adr: dataFromApi[i].CURRENT_REVENUE
                          ? Math.round(
                              dataFromApi[i].CURRENT_REVENUE /
                                dataFromApi[i].CURRENT_ROOM,
                            )
                          : 0,
                        // lyAdr: dataFromApi[i].LY_ADR,
                        lyAdr: dataFromApi[i].LY_Revenue
                          ? Math.round(
                              dataFromApi[i].LY_Revenue /
                                dataFromApi[i].LY_ROOM,
                            )
                          : 0,
                        revenue: dataFromApi[i].CURRENT_REVENUE,
                        lyRevenue: dataFromApi[i].LY_Revenue,
                      },
                    ],
                  },
                ],
              },
            ],
          };

          groupingJson = [...groupingJson, newObj];
        }
      }
      let jsonForPickupAdr = [...groupingJson];
      let totalMarketSegmentPickupAdr = 0,
        totalMarketSegment = 0;

      const marketSegmentPickupAdr = () => {
        let pickupAdrValue = 0,
          totalRateCode = 0;
        for (let i = 0; i < jsonForPickupAdr?.length; i++) {
          for (let j = 0; j < jsonForPickupAdr?.[i]?.items?.length; j++) {
            pickupAdrValue =
              pickupAdrValue +
              (jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr
                ? parseInt(jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr)
                : 0);
            if (
              jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr &&
              jsonForPickupAdr?.[i]?.items?.[j]?.pickupAdr !== "0"
            ) {
              totalRateCode = totalRateCode + 1;
            }
          }
          jsonForPickupAdr[i].pickupAdr = pickupAdrValue
            ? Math.round(pickupAdrValue / totalRateCode)
            : 0;
          if (pickupAdrValue) {
            totalMarketSegmentPickupAdr =
              totalMarketSegmentPickupAdr +
              Math.round(pickupAdrValue / totalRateCode);
            totalMarketSegment = totalMarketSegment + 1;
          }
          pickupAdrValue = 0;
          totalRateCode = 0;
        }
        totalRef.current.pickupAdr = totalMarketSegmentPickupAdr
          ? Math.round(totalMarketSegmentPickupAdr / totalMarketSegment)
          : 0;
      };

      const rateCodePickupAdr = () => {
        let pickupAdrValue = 0,
          totalCompany = 0;
        for (let i = 0; i < jsonForPickupAdr?.length; i++) {
          for (let j = 0; j < jsonForPickupAdr?.[i]?.items?.length; j++) {
            for (
              let k = 0;
              k < jsonForPickupAdr?.[i]?.items?.[j]?.items?.length;
              k++
            ) {
              pickupAdrValue =
                pickupAdrValue +
                (jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr
                  ? parseInt(
                      jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr,
                    )
                  : 0);
              if (
                jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr &&
                jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.pickupAdr !== "0"
              ) {
                totalCompany = totalCompany + 1;
              }
            }
            jsonForPickupAdr[i].items[j].pickupAdr = pickupAdrValue
              ? Math.round(pickupAdrValue / totalCompany)
              : 0;
            pickupAdrValue = 0;
            totalCompany = 0;
          }
        }
      };

      const companyPickupAdr = () => {
        let pickupAdrValue = 0,
          totalGuest = 0;
        for (let i = 0; i < jsonForPickupAdr?.length; i++) {
          for (let j = 0; j < jsonForPickupAdr?.[i]?.items?.length; j++) {
            for (
              let k = 0;
              k < jsonForPickupAdr?.[i]?.items?.[j]?.items?.length;
              k++
            ) {
              for (
                let l = 0;
                l <
                jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.length;
                l++
              ) {
                pickupAdrValue =
                  pickupAdrValue +
                  (jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[l]
                    ?.pickupAdr
                    ? parseInt(
                        jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[
                          l
                        ]?.pickupAdr,
                      )
                    : 0);
                if (
                  jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[l]
                    ?.pickupAdr !== "0" &&
                  jsonForPickupAdr?.[i]?.items?.[j]?.items?.[k]?.items?.[l]
                    ?.pickupAdr
                ) {
                  totalGuest = totalGuest + 1;
                }
              }
              jsonForPickupAdr[i].items[j].items[k].pickupAdr = pickupAdrValue
                ? Math.round(pickupAdrValue / totalGuest)
                : 0;
              pickupAdrValue = 0;
              totalGuest = 0;
            }
          }
        }
      };

      companyPickupAdr();
      rateCodePickupAdr();
      marketSegmentPickupAdr();

      // setSingleDateData(groupingJson);
      setSingleDateData(jsonForPickupAdr);
      setLoading(false);
    }

    if (!response?.isValidate) {
      setSingleDateData(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!showModal) {
      return;
    }

    const requestKey = JSON.stringify({
      selectedDate,
      pickupDate: moment(pickupDateRef.current).format("YYYY-MM-DD"),
      isRMSRequest: RMSRequest !== null,
    });

    if (
      inFlightRequestRef.current &&
      activeRequestKeyRef.current === requestKey
    ) {
      return;
    }

    inFlightRequestRef.current = true;
    activeRequestKeyRef.current = requestKey;
    const fetchData = async () => {
      if (RMSRequest !== null) {
        await getBucketClickedDateData();
      } else {
        await getSingleDateData();
      }
      inFlightRequestRef.current = false;
    };

    fetchData();
  }, [selectedDate, changeDate, RMSRequest, showModal]);

  useEffect(() => {
    setSelectedPickupDateType(PickupDays ? PickupDays : "7Day");
    let subtractdays = PickupDays ? parseInt(PickupDays.replace("Day")) : 7;
    let date = moment(asOfDate).subtract(subtractdays, "d");
    pickupDateRef.current = date;
  }, [PickupDays]);

  const handleShowHideRow = (className, itemDetail) => {
    if (document.getElementById(className) !== null) {
      if (document.getElementById(className).classList.contains("active")) {
        document.getElementById(className).classList.remove("active");
      } else {
        document.getElementById(className).classList.add("active");
      }
    }

    const removeClass = (classNameDetail) => {
      const classList = document.getElementsByClassName(classNameDetail);
      for (let i = 0; i < classList?.length; i++) {
        if (classList[i].classList.contains("nestedTableRowNone")) {
          classList[i].classList.remove("nestedTableRowNone");
          classList[i].classList.add("singleDateSummmaryTr");
        } else {
          classList[i].classList.add("nestedTableRowNone");
          classList[i].classList.remove("singleDateSummmaryTr");
        }
      }
    };

    removeClass(className);

    const addChildClass = (childClassName) => {
      const classList = document.getElementsByClassName(childClassName);
      for (let i = 0; i < classList?.length; i++) {
        if (!classList[i].classList.contains("nestedTableRowNone")) {
          classList[i].classList.add("nestedTableRowNone");
          classList[i].classList.remove("singleDateSummmaryTr");
        }
      }
    };

    const removeAllClass = (childItems) => {
      for (let i = 0; i < childItems?.length; i++) {
        addChildClass(childItems[i]?.guid);

        if (
          Array.isArray(childItems[i]?.items) &&
          childItems[i]?.items?.length > 0
        ) {
          removeAllClass(childItems[i]?.items);
        }
      }
    };

    if (Array.isArray(itemDetail?.items) && itemDetail?.items?.length > 0) {
      removeAllClass(itemDetail?.items);
    }
  };

  const checkActiveRow = (e, guid, itemDetail) => {
    if (e.currentTarget.classList.contains("active")) {
      e.currentTarget.classList.remove("active");
      e.currentTarget.classList.remove("singleDateSummmaryTr");
    } else {
      e.currentTarget.classList.add("active");
      e.currentTarget.classList.add("singleDateSummmaryTr");
    }

    // if (guid) {
    //   const classList = document.getElementsByClassName(guid);
    //   for (let i = 0; i < classList?.length; i++) {
    //     if (
    //       classList[i].classList.contains("active") &&
    //       classList[i].classList.contains("dropDownTrColor")
    //     ) {
    //       classList[i].classList.remove("active");
    //       classList[i].classList.remove("dropDownTrColor");
    //     }
    //   }
    // }
    // const removeFromGuid = (guid) => {
    //   const classList = document.getElementsByClassName(guid);
    //   for (let i = 0; i < classList?.length; i++) {
    //     if (
    //       classList[i].classList.contains("active") &&
    //       classList[i].classList.contains("dropDownTrColor")
    //     ) {
    //       classList[i].classList.remove("active");
    //       classList[i].classList.remove("dropDownTrColor");
    //     }
    //   }
    // };
    // const removeClass = (childItems) => {
    //   removeFromGuid(childItems?.[0]?.guid);
    //   if (
    //     Array.isArray(childItems?.[0]?.items) &&
    //     childItems?.[0]?.items?.length > 0
    //   ) {
    //     removeClass(childItems?.[0]?.items);
    //   }
    // };

    // if (Array.isArray(itemDetail?.items) && itemDetail?.items?.length > 0) {
    //   removeClass(itemDetail?.items);
    // }
  };
  return (
    <div
      className={`GroupNameModalMain singleDateSummaryModalMain ToolsSingleTicketPopUpMain`}
    >
      <div className="GroupNameModalHeader">
        <div className="singleDateSummaryModalHeader">
          {isTotalHeatMapClick ? (
            <h2>{`Summary (${selectedDate.startDateObj ? commonService.getDateInFormat(selectedDate.startDateObj) : ""} - ${selectedDate.endDateObj ? commonService.getDateInFormat(selectedDate.endDateObj) : ""})`}</h2>
          ) : requestFor === "PMS_Booking_Window" ? 
          (<h2>{`Monthly Summary ${
              selectedDate && commonService.getDateInFormat(selectedDate) ? "(" + commonService.getDateInFormat(selectedDate) + ")" : ""
            }`}</h2>) : (
            <h2>{`Single Date Summary ${
              selectedDate && commonService.getDateInFormat(selectedDate) ? "(" + commonService.getDateInFormat(selectedDate) + ")" : ""
            }`}</h2>
          )}
          <div>
            <Form.Select
              id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "Pickup-dropdown", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
              className="singleDateSummaryDropdown"
              value={selectedPickupDateType}
              onChange={(e) => {
                if (e.target.value === "1Day") {
                  pickupDateRef.current = moment(asOfDate).subtract(1, "d");
                } else if (e.target.value === "7Day") {
                  pickupDateRef.current = moment(asOfDate).subtract(7, "d");
                } else if (e.target.value === "14Day") {
                  pickupDateRef.current = moment(asOfDate).subtract(14, "d");
                }
                setSelectedPickupDateType(e.target.value);
                setChangeDate((prev) => !prev);
              }}
            >
              <option value="">Select Pickup</option>
              <option value="1Day">1 Day Pickup</option>
              <option value="7Day">7 Day Pickup</option>
              <option value="14Day">14 Day Pickup</option>
            </Form.Select>
          </div>
          <div className="width100 single-date-summary-date-picker">
            <DatePicker
              id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "datePicker", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
              portalId="datepicker-root"
              maxDate={new Date(maxDate)}
              selected={new Date(pickupDateRef.current)}
              onChange={(date) => {
                pickupDateRef.current = date;
                setSelectedPickupDateType("");
                setChangeDate((prev) => !prev);
              }}
            />
          </div>
        </div>
        <button
          id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "close-btn", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
          className="btn-close"
          onClick={closeModal}
        ></button>
      </div>

      <div className="singleDateSummaryModalContent">
        <div className="ViewPropertySetupTable">
          <div className="table__container">
            <div className="stripped__table">
              <Table responsive>
                <thead>
                  <tr>
                    <th className="border_right">Market Segment</th>
                    <th className="text-center">Room</th>
                    <th className="border_right text-center">LY</th>
                    <th>Arr Date</th>
                    <th className="text-center">LOS</th>
                    <th className="text-center">Pickup From</th>
                    <th className="border_right text-end">ADR Pickup</th>
                    <th className="text-end">ADR</th>
                    <th className="border_right text-end">LY</th>
                    <th className="text-end">Revenue</th>
                    <th className="text-end">LY</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr style={{ height: "80px", position: "relative" }}>
                      <Loader />
                    </tr>
                  ) : (
                    singleDateData &&
                    singleDateData?.map((item, index) => {
                      return (
                        <>
                          <tr id={item?.guid}>
                            <td className="border_right">
                              <div
                                id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "toggle-Market-Segment", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
                                className={`d-flex gap-2`}
                                onClick={() => toggleExpandedRow(item?.guid)}
                              >
                                <p>{item?.name}</p>
                                <img src={downArrow} />
                              </div>
                            </td>
                            <td className="text-center">{item?.room}</td>
                            <td className="border_right text-center">
                              {item?.lyRoom}
                            </td>
                            <td>
                              {item?.arrDate
                                ? commonService.getDateInFormat(item?.arrDate)
                                : ""}
                            </td>
                            <td></td>
                            <td className="text-center">{item?.pickupFrom}</td>
                            <td className="border_right text-end">
                              {commonService.formateAmount(item?.pickupAdr)}
                            </td>
                            <td className="text-end">
                              {commonService.formateAmount(item?.adr)}
                            </td>
                            <td className="text-end border_right">
                              {commonService.formateAmount(item?.lyAdr)}
                            </td>
                            <td className="text-end">
                              {commonService.formateAmount(item?.revenue)}
                            </td>
                            <td className="text-end">
                              {commonService.formateAmount(item?.lyRevenue)}
                            </td>
                          </tr>
                          {expandedRows[item?.guid] &&
                            Array.isArray(item?.items) &&
                            item?.items?.length > 0 &&
                            item?.items?.map((rateCodeItem, rateCodeIndex) => (
                              <>
                                <tr id={rateCodeItem?.guid}>
                                  <td className="border_right">
                                    <div
                                    id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "toggle-Rate-Code", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
                                      style={{ paddingLeft: "10px" }}
                                      className="d-flex gap-2"
                                      onClick={() =>
                                        toggleExpandedRow(rateCodeItem?.guid)
                                      }
                                    >
                                      <p>{rateCodeItem?.name}</p>
                                      <img src={downArrow} />
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    {rateCodeItem?.room}
                                  </td>
                                  <td className="border_right text-center">
                                    {rateCodeItem?.lyRoom}
                                  </td>
                                  <td>
                                    {rateCodeItem?.arrDate
                                      ? commonService.getDateInFormat(
                                          rateCodeItem?.arrDate,
                                        )
                                      : ""}
                                  </td>
                                  <td></td>
                                  <td className="text-center">
                                    {rateCodeItem?.pickupFrom}
                                  </td>
                                  <td className="border_right text-end">
                                    {commonService.formateAmount(
                                      rateCodeItem?.pickupAdr,
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {commonService.formateAmount(
                                      rateCodeItem?.adr,
                                    )}
                                  </td>
                                  <td className="text-end border_right">
                                    {commonService.formateAmount(
                                      rateCodeItem?.lyAdr,
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {commonService.formateAmount(
                                      rateCodeItem?.revenue,
                                    )}
                                  </td>
                                  <td className="text-end">
                                    {commonService.formateAmount(
                                      rateCodeItem?.lyRevenue,
                                    )}
                                  </td>
                                </tr>
                                {expandedRows[rateCodeItem?.guid] &&
                                  Array.isArray(rateCodeItem?.items) &&
                                  rateCodeItem?.items?.length > 0 &&
                                  rateCodeItem?.items?.map(
                                    (companyItem, companyIndex) => (
                                      <>
                                        <tr id={companyItem?.guid}>
                                          <td className="border_right">
                                            <div
                                              id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "toggle-Company", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
                                              style={{ paddingLeft: "20px" }}
                                              className="d-flex gap-2"
                                              onClick={() =>
                                                toggleExpandedRow(
                                                  companyItem?.guid,
                                                )
                                              }
                                            >
                                              <p>{companyItem?.name}</p>
                                              <img src={downArrow} />
                                            </div>
                                          </td>
                                          <td className="text-center">
                                            {companyItem?.room}
                                          </td>
                                          <td className="border_right text-center">
                                            {companyItem?.lyRoom}
                                          </td>
                                          <td>
                                            {companyItem?.arrDate
                                              ? commonService.getDateInFormat(
                                                  companyItem?.arrDate,
                                                )
                                              : ""}
                                          </td>
                                          <td></td>
                                          <td className="text-center">
                                            {companyItem?.pickupFrom}
                                          </td>
                                          <td className="border_right text-end">
                                            {commonService.formateAmount(
                                              companyItem?.pickupAdr,
                                            )}
                                          </td>
                                          <td className="text-end">
                                            {commonService.formateAmount(
                                              companyItem?.adr,
                                            )}
                                          </td>
                                          <td className="text-end border_right">
                                            {commonService.formateAmount(
                                              companyItem?.lyAdr,
                                            )}
                                          </td>
                                          <td className="text-end">
                                            {commonService.formateAmount(
                                              companyItem?.revenue,
                                            )}
                                          </td>
                                          <td className="text-end">
                                            {commonService.formateAmount(
                                              companyItem?.lyRevenue,
                                            )}
                                          </td>
                                        </tr>
                                        {expandedRows[companyItem?.guid] &&
                                          Array.isArray(companyItem?.items) &&
                                          companyItem?.items?.length > 0 &&
                                          companyItem?.items?.map(
                                            (guestItem, guestIndex) => (
                                              <tr
                                              id={commonService.generateGlobalClickTrackerID(`Summary-Popup`, "guest-Row", `${isTotalHeatMapClick ? selectedDate.startDateObj : selectedDate}`)}
                                                onClick={(e) => {
                                                  checkActiveRow(e);
                                                }}
                                              >
                                                <td className="border_right">
                                                  <div
                                                    style={{
                                                      paddingLeft: "30px",
                                                    }}
                                                    className="d-flex gap-2"
                                                  >
                                                    <p>{guestItem?.name}</p>
                                                  </div>
                                                </td>
                                                <td className="text-center">
                                                  {guestItem?.room}
                                                </td>
                                                <td className="border_right text-center">
                                                  {guestItem?.lyRoom}
                                                </td>
                                                <td>
                                                  {guestItem?.arrDate
                                                    ? commonService.getDateInFormat(
                                                        guestItem?.arrDate,
                                                      )
                                                    : ""}
                                                </td>
                                                <td className="text-center">
                                                  {guestItem?.LOS}
                                                </td>
                                                <td className="text-center">
                                                  {guestItem?.pickupFrom}
                                                </td>
                                                <td className="border_right text-end">
                                                  {commonService.formateAmount(
                                                    guestItem?.pickupAdr,
                                                  )}
                                                </td>
                                                <td className="text-end">
                                                  {guestItem?.adr
                                                    ? commonService.formateAmount(
                                                        guestItem?.adr,
                                                      )
                                                    : commonService.formateAmount(
                                                        0,
                                                      )}
                                                </td>
                                                <td className="text-end border_right">
                                                  {guestItem?.lyAdr
                                                    ? commonService.formateAmount(
                                                        guestItem?.lyAdr,
                                                      )
                                                    : commonService.formateAmount(
                                                        0,
                                                      )}
                                                </td>
                                                <td className="text-end">
                                                  {commonService.formateAmount(
                                                    guestItem?.revenue,
                                                  )}
                                                </td>
                                                <td className="text-end">
                                                  {commonService.formateAmount(
                                                    guestItem?.lyRevenue,
                                                  )}
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                      </>
                                    ),
                                  )}
                              </>
                            ))}
                          {index === singleDateData?.length - 1 && (
                            <tr>
                              <td className="boldTd border_right">Total</td>
                              <td className="boldTd text-center">
                                {totalRef.current.room}
                              </td>
                              <td className="boldTd text-center border_right">
                                {totalRef.current.lyRoom}
                              </td>
                              <td className="boldTd"></td>
                              <td className="boldTd"></td>
                              <td className="boldTd text-center">
                                {totalRef.current.pickupFrom}
                              </td>
                              <td className="boldTd text-end border_right">
                                {commonService.formateAmount(
                                  totalRef.current.pickupAdr,
                                )}
                                {/* {countForPickupAdrDivision.current > 0
                                  ? Math.round(
                                      totalRef.current.pickupAdr /
                                        countForPickupAdrDivision.current
                                    )
                                  : totalRef.current.pickupAdr} */}
                              </td>
                              <td className="boldTd text-end">
                                {totalRef.current.revenue > 0 &&
                                totalRef.current.room > 0
                                  ? commonService.formateAmount(
                                      Math.round(
                                        totalRef.current.revenue /
                                          totalRef.current.room,
                                      ),
                                    )
                                  : commonService.formateAmount(0)}
                              </td>
                              <td className="boldTd text-end border_right">
                                {totalRef.current.lyRevenue > 0 &&
                                totalRef.current.lyRoom > 0
                                  ? commonService.formateAmount(
                                      Math.round(
                                        totalRef.current.lyRevenue /
                                          totalRef.current.lyRoom,
                                      ),
                                    )
                                  : commonService.formateAmount(0)}
                              </td>
                              <td className="boldTd text-end">
                                {commonService.formateAmount(
                                  totalRef.current.revenue,
                                )}
                              </td>
                              <td className="boldTd text-end">
                                {commonService.formateAmount(
                                  totalRef.current.lyRevenue,
                                )}
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleDateSummaryModal;
